import { useTranslation } from "react-i18next";
import { Form } from "semantic-ui-react";

import { Element } from "components/ReactScroll/index";
import { createFormHelper } from "lib/Form";
import "modules/CommunicationSettings/CustomerCom.scss";

import type { CommunicationSetting } from "models";

type DiagnoseOverviewProps = {
  tabId: string;
};

const FormHelper = createFormHelper<CommunicationSetting>();

export const DiagnoseOverview = ({ tabId }: DiagnoseOverviewProps) => {
  const { t } = useTranslation();

  return (
    <Element name={tabId} className="customer-com-wrapper">
      <h3>{t("v8_diagnose_overview", "Diagnose Overview")}</h3>
      <div>
        <Form.Group className="mt-16">
          <Form.Field width={3}>
            <span className="items-center">
              <FormHelper.Field.Checkbox name="diagnose_cc_testing_mode" label={t("v8_testing_mode", "Testing mode")} />
            </span>
          </Form.Field>
          <Form.Field width={5}>
            <label>{t("v8_email", "E-mail")}</label>
            <FormHelper.Field.Input inputProps={{ placeholder: t("v8_email", "E-mail"), fluid: true }} name="diagnose_cc_testing_email" />
          </Form.Field>
          <Form.Field width={8}>
            <label>{t("v8_phone", "Phone")}</label>
            <FormHelper.Field.Input inputProps={{ placeholder: t("v8_phone", "Phone"), fluid: true, type: "Phone" }} name="diagnose_cc_testing_phone" />
          </Form.Field>
        </Form.Group>

        <Form.Group className="mt-14">
          <Form.Field width={8}>
            <label>{t("v8_welcome_text", "Welcome text")}</label>
            <FormHelper.Field.TextArea textAreaProps={{ placeholder: `${t("v8_hello", "Hello")}!` }} name="repair_overview_welcome_text" />
          </Form.Field>

          <Form.Field width={8}>
            <label>{t("v8_success_text", "Success text")}</label>
            <FormHelper.Field.TextArea textAreaProps={{ placeholder: `${t("v8_thank_you", "Thank You")}!` }} name="success_text" />
          </Form.Field>
        </Form.Group>

        <div className="row mt-24">
          <div className="full">
            <Form.Field>
              <p className="title">{t("v8_customer_inputs", "Customer inputs")}</p>
              <span className="items-center">
                <FormHelper.Field.Checkbox name="diagnose_overview_remarks_enabled" label={t("v8_enable_remarks", "Enable remarks")} />
              </span>
              <span className="items-center">
                <FormHelper.Field.Checkbox
                  name="diagnose_overview_name_visible"
                  label={t("v8_ask_the_customer_to_enter_his_name", "Ask the Customer to enter his name")}
                />
              </span>
            </Form.Field>
          </div>

          <div className="full">
            <Form.Field>
              <p className="title">{t("v8_dont_fix_button", "Don't Fix Button")}</p>
              <span className="items-center">
                <FormHelper.Field.Checkbox name="enable_not_fixed_advised" label={t("v8_enable_for_advised_items", "Enable for Advised Items")} />
              </span>
              <div className="items-center">
                <FormHelper.Field.Checkbox name="enable_not_fixed_critical" label={t("v8_enable_for_critical_items", "Enable for Critical Items")} />
              </div>
              <span className="items-center">
                <FormHelper.Field.Checkbox
                  name="enable_not_fix_without_status"
                  label={t("v8_enable_for_interventions_without_status", "Enable for interventions without status")}
                />
              </span>
            </Form.Field>
          </div>
        </div>
        <div className="row mt-24">
          <div className="full"></div>
          <div className="full">
            <Form.Field>
              <p className="title">{t("v8_skip_items", "Skip items")}</p>
              <span className="items-center">
                <FormHelper.Field.Checkbox name="skip_optional_items" label={t("v8_skip_advised_items", "Skip advised items")} />
              </span>
              <span className="items-center">
                <FormHelper.Field.Checkbox name="skip_without_status_items" label={t("v8_skip_items_without_status", "Skip items without status")} />
              </span>
            </Form.Field>
          </div>
        </div>
      </div>
    </Element>
  );
};
